import {
  isLoggedIn
} from "axios-jwt";

export default {
  token: null,
  logged: isLoggedIn(),
};
